
<ion-tabs >
  <ion-tab-bar class="ion-tab-bar" slot="bottom">
    <ion-tab-button [class.selected-button]="home" [routerLink]="['']">
      <ion-label [class.selected]="home" [class.label]="!home">Servicios</ion-label>
      <ion-icon class="ion-tab-icon" name={{homeIcon}}></ion-icon>
    </ion-tab-button>
    <ion-tab-button [class.selected-button]="mediagenda" [routerLink]="['/medi-agenda']"> 
      <ion-label [class.selected]="mediagenda" [class.label]="!mediagenda">Mediagenda</ion-label>
      <ion-icon class="ion-tab-icon" name={{mediagendaIcon}}></ion-icon>
    </ion-tab-button>
    <ion-tab-button [class.selected-button]="wallet" [routerLink]="['/billeteras']">
      <ion-label [class.selected]="wallet" [class.label]="!wallet">Billetera</ion-label>
      <ion-icon   class="ion-tab-icon" name={{billeteraIcon}}></ion-icon>
    </ion-tab-button>
  </ion-tab-bar>
</ion-tabs>
  